import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title} data-id="element-40">
      <div className="absolute inset-0 bg-black/60 animate-[fadeIn_200ms_ease-out]" onClick={onClose} data-id="element-41" />
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col animate-[slideUp_300ms_ease-out]" data-id="element-42">
        <div className="flex items-center justify-between p-6 border-b border-gray-100 flex-shrink-0" data-id="element-43">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-44">{title}</h2>
          <button onClick={onClose} className="h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors text-gray-500" aria-label="Cerrar" data-id="element-45">
            <XIcon className="h-5 w-5" data-id="element-46" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-gray-600 text-sm leading-relaxed space-y-4" data-id="element-47">
          {children}
        </div>
        <div className="p-4 border-t border-gray-100 flex-shrink-0" data-id="element-48">
          <button onClick={onClose} className="w-full py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors" data-id="element-49">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}